import { Component, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CommonService } from 'src/app/services/common/common.service';
import { renderAsync } from 'docx-preview';

@Component({
  selector: 'app-preview-document-modal',
  templateUrl: './preview-document-modal.component.html',
  styleUrls: ['./preview-document-modal.component.scss'],
})
export class PreviewDocumentModalComponent {
  @ViewChild('previewDocumentModal')
  previewDocumentModal!: ModalDirective;
  @ViewChild('docContainer', { static: false }) docContainer!: ElementRef;
  previewUrl: any = '';
  documentType: string = '';
  document: any;
  documentName: any;

  constructor(
    private sanitizer: DomSanitizer,
    private commonService: CommonService
  ) {}

  openPreviewDocument(filePath: any, fName?: string) {
    let fileName = '';
    let fileUrl = '';
    this.documentType = '';
    this.previewUrl = '';
    this.document = filePath;
    this.documentName = fName;
    if (filePath instanceof File) {
      fileName = filePath.name;
      fileUrl = URL.createObjectURL(filePath);
      this.setDocumentType(fileName);

      if (this.documentType == 'xls') {
        return this.downloadFile();
      }

      if (this.documentType !== 'doc') {
        this.setPreviewUrl(fileUrl);
      }

      if (this.documentType == 'doc') {
        this.renderDocument(filePath);
      }
    } else {
      fileName = filePath;
      this.setDocumentType(fileName);

      if (this.documentType == 'xls') {
        return this.downloadFile();
      }

      this.commonService
        .DownloadDocumentDataAsync(filePath)
        .subscribe((res: any) => {
          if (this.documentType === 'pdf') {
            const pdfBlob = new Blob([res], { type: 'application/pdf' });
            const fileUrl = URL.createObjectURL(pdfBlob);
            this.setPreviewUrl(fileUrl + '#toolbar=0');
          }

          if (this.documentType !== 'doc' && this.documentType !== 'pdf') {
            const fileUrl = URL.createObjectURL(res);
            this.setPreviewUrl(fileUrl);
          }

          if (this.documentType == 'doc') {
            this.renderDocument(res);
          }
        });
    }

    this.previewDocumentModal.show();
  }

  setDocumentType(fileName: string) {
    console.log(fileName);
    if (fileName.endsWith('.pdf')) {
      this.documentType = 'pdf';
    } else if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) {
      this.documentType = 'doc';
    } else if (fileName.match(/\.(jpg|jpeg|png|gif)$/)) {
      this.documentType = 'image';
    } else if (
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx') ||
      fileName.endsWith('.xlsm')
    ) {
      this.documentType = 'xls';
    }
  }

  setPreviewUrl(url: string) {
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  renderDocument(file: File) {
    setTimeout(() => {
      this.docContainer.nativeElement.innerHTML = '';
      renderAsync(file, this.docContainer?.nativeElement);
    }, 500);
  }

  downloadFile() {
    if (this.document instanceof File) {
      const url = window.URL.createObjectURL(this.document);
      const anchor = document.createElement('a');
      const fileName = this.documentName
        ? this.documentName
        : this.document.name || 'downloaded-file';
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      window.URL.revokeObjectURL(url);
    } else if (this.documentType === 'pdf') {
      const safeUrl: any = this.previewUrl;
      const url = safeUrl.changingThisBreaksApplicationSecurity;
      const a = document.createElement('a');
      a.href = url.split('#')[0]; // remove toolbar
      a.download = this.documentName || 'download.pdf';
      a.click();
    } else {
      this.commonService.openDocument(this.document, this.documentName);
    }
  }
}
